/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {dismissBadge} from '../api'

export const useMutationDismissBadge = createReactQueryMutationHook('dismissBadge', dismissBadge)
